import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import CopyIcon from '../../../shared/CopyIcon';
import { CopyDataToClipBoard } from '../../../../../util/CommonUtils';
import { getActivationKey } from '../../../../../actions/activationKeyActions';

const ActivationKeyTable = ({ activationKeys, openActivationKeyDetails }) => {
  return (
    <div className="accounts-roles-table">
      <div className="table-wrapper">
        <div className="table-head">
          <table>
            <thead>
              <tr className="table-row table-row-head">
                <th className="table-cell table-cell-name">
                  <span className="text-left display-block padding-left-15">
                    Activation Key{' '}
                  </span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">
                    Created by{' '}
                  </span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">
                    Created Date
                  </span>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div className="table-body">
          <table>
            <tbody>
              {activationKeys.length &&
                activationKeys.map(actKey => {
                  return (
                    <tr
                      key={`${actKey.activationKey}`}
                      className="table-row table-row-body"
                    >
                      <td className="table-cell table-cell-name">
                        <button
                          type="button"
                          onClick={() => openActivationKeyDetails(actKey)}
                          className="table-cell-button activationKey"
                        >
                          <span className="col-text ">
                           {`********************************${actKey.activationKey}`}
                          </span>
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            CopyDataToClipBoard(actKey, true, getActivationKey)
                          }
                          className="table-cell-button"
                        >
                          <CopyIcon />
                        </button>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text text-left">
                          {actKey.createdBy}
                        </span>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text text-left">
                          {moment(actKey.creationDate).format(
                            'MM DD YYYY hh:mm:ss'
                          )}
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

ActivationKeyTable.propTypes = {
  ActivationKeys: PropTypes.arrayOf(Object),
  openActivationKeyDetails: PropTypes.func,
};

export default ActivationKeyTable;
